import { render, staticRenderFns } from "./PlayAvatar.vue?vue&type=template&id=5b01b594&scoped=true"
import script from "./PlayAvatar.vue?vue&type=script&lang=js"
export * from "./PlayAvatar.vue?vue&type=script&lang=js"
import style0 from "./PlayAvatar.vue?vue&type=style&index=0&id=5b01b594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01b594",
  null
  
)

export default component.exports